export default ({product = null} = {}) => {

    const {id = '', name = '', seo = {}, images, event_price = 0, has_stock, seo_url = null} = product || {}

    const description = seo?.description?.replace(/&nbsp;/gi, ' ')

    const image = images && images?.length ? images[0] : ''

    const {t} = useI18n()

    const {getProductLinks, getRobotsMeta} = useSeoMeta()

    const currentYear = new Date().getFullYear()

    return {
        meta: [
            {hid: 'title', name: 'title', content: name},
            {
                hid: 'description',
                name: 'description',
                content: t('seo.product_description_template', {name})
            },
            {
                hid: 'og:image',
                property: 'og:image',
                content: image
            },
            {property: 'og:image:width', content: '740'},
            {property: 'og:image:height', content: '300'},
            // Twitter
            {name: 'twitter:card', content: 'summary'},
            {name: 'twitter:title', content: name},
            {
                name: 'twitter:description',
                content: description
            },
            {name: 'twitter:site', content: '@niceonesa'},
            {name: 'twitter:image', content: image},

            {name: 'rating', content: 'General'},
            {name: 'Classification', content: 'Business'},
            {
                name: 'copyright',
                content: `Copyright © ${currentYear} NICE ONE || all right reserved`
            },

            {property: 'og:type', content: 'product.item'},
            {property: 'og:title', content: name},
            {
                property: 'og:description',
                content: description
            },
            {
                property: 'og:image',
                itemprop: 'image',
                content: image
            },
            {
                property: 'og:image:url',
                itemprop: 'image',
                content: image
            },
            {property: 'og:image:alt', content: name},
            {
                property: 'og:site_name',
                content: 'نايس ون'
            },
            {
                property: 'og:url',
                content: seo_url?.replace(/\/$/, '') || ''
            },
            {
                property: 'og:email',
                content: 'info@niceonesa.com'
            },
            {
                property: 'og:phone_number',
                content: '920033385'
            },
            {property: 'product:condition', content: 'new'},
            {
                property: 'product:availability',
                content: has_stock ? 'in stock' : 'out of stock'
            },
            {
                property: 'product:price:amount',
                content: event_price
            },
            {property: 'product:price:currency', content: 'SAR'},
            {
                property: 'product:retailer_item_id',
                content: id
            },
            ...getRobotsMeta({notFound: !id}),
        ],
        link: () => [...(getProductLinks({link: seo_url, notFound: !id}) || [])]
    }
}
